import { render, staticRenderFns } from "./DocumentCategory.vue?vue&type=template&id=0ac21cfb&"
import script from "./DocumentCategory.vue?vue&type=script&lang=js&"
export * from "./DocumentCategory.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCategory.vue?vue&type=style&index=0&id=0ac21cfb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports